export default "__VITE_ASSET__CnRAhmw$__"